/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_AllInputs */

const en_follow_all = /** @type {(inputs: Follow_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow all changes`)
};

/**
* | output |
* | --- |
* | "Follow all changes" |
*
* @param {Follow_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const follow_all = /** @type {((inputs?: Follow_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_follow_all(inputs)
});